import CookieCheck from"./src/CookieCheck";if(!window.customElements.get("cookie-check")){window.customElements.define("cookie-check",CookieCheck)}